import { API_URLS, ASYNC_STATE, MAPPED_IDS } from '@brighterion/utils/constants';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAppStore } from '../../store/index';
import { getApi } from '../../services/apiService';
import { RoleService } from '../../services';

const GlobalPollerManager = () => {
    const startPolling = useAppStore.use.startPolling?.();
    const showAlert = useAppStore.use.showAlert?.();
    const setConfigStatus = useAppStore.use.setConfigStatus?.();
    const setOperationBy = useAppStore.use.setOperationBy?.();
    const queryClient = useQueryClient();
    const PENDING_HISTORY_QUERY_KEY = ['PendingHistoryData'];
    const GET_CONFIG_QUERY_KEY = ['ConfigurationData'];
    const successMessage = ASYNC_STATE.CONFIG_CHANGES_SUCCESS_MESSAGE;
    const failMessage = ASYNC_STATE.CONFIG_CHANGES_FAIL_MESSAGE;
    const setListPollingData = useAppStore.use.setListPollingData?.();
    const { hasWLSConfigAdminAccess, hasWLSListAdminAccess } = RoleService;

    useEffect(() => {
        // Configuration Poller
        let tempConfigurationStatus = '';
        if (hasWLSConfigAdminAccess) {
            startPolling({
                id: 'getConfigStatusPolling',
                apiCall: () =>
                    getApi({
                        url: API_URLS.getConfigStatusPolling
                    }),
                interval: ASYNC_STATE.POLLING_INTERVAL,
                onSuccess: (responseData) => {
                    if (
                        responseData.data?.status === ASYNC_STATE.APPROVED_STATUS &&
                        (tempConfigurationStatus === ASYNC_STATE.PROCESSING_STATUS ||
                            tempConfigurationStatus === ASYNC_STATE.CONFIG_NEEDS_REVIEW_STATUS)
                    ) {
                        queryClient?.invalidateQueries(PENDING_HISTORY_QUERY_KEY);
                        queryClient?.invalidateQueries(GET_CONFIG_QUERY_KEY);
                        showAlert({
                            type: 'success',
                            message: successMessage
                        });
                    }
                    if (
                        responseData.data?.status === ASYNC_STATE.FAILED_STATUS &&
                        (tempConfigurationStatus === ASYNC_STATE.PROCESSING_STATUS ||
                            tempConfigurationStatus === ASYNC_STATE.CONFIG_NEEDS_REVIEW_STATUS)
                    ) {
                        queryClient?.invalidateQueries(PENDING_HISTORY_QUERY_KEY);
                        queryClient?.invalidateQueries(GET_CONFIG_QUERY_KEY);
                        showAlert({
                            type: 'danger',
                            message: `${failMessage}`,
                            linkText: 'View configuration',
                            linkTo: '/configuration',
                            linkType: 'link'
                        });
                    }
                    tempConfigurationStatus = responseData.data?.status;
                    setConfigStatus(responseData.data?.status);
                    setOperationBy({ ...responseData.data?.operationBy });
                },
                onError: (error) => {
                    console.error('Configuration status Polling error :', error);
                }
            });
        }

        // Custom list Poller
        const prevStatusMap = new Map();
        if (hasWLSListAdminAccess) {
            startPolling({
                id: 'getInternListStatusPolling',
                apiCall: () =>
                    getApi({
                        url: API_URLS.getInternListStatusPolling
                    }),
                interval: ASYNC_STATE.POLLING_INTERVAL,
                onSuccess: (responseData) => {
                    const newData = responseData?.data?.changes || [];

                    newData.forEach((item: any) => {
                        const prevStatus = prevStatusMap.get(item.listId);
                        if (prevStatus !== undefined && prevStatus !== item.status && item.status === 'approved') {
                            showAlert({
                                type: 'success',
                                message: ASYNC_STATE.LIST_CHANGES_SUCCESS_MESSAGE(item.listName, item.revisionId)
                            });
                        }

                        if (prevStatus !== undefined && prevStatus !== item.status && item.status === 'failed') {
                            const id = MAPPED_IDS.get(item?.listName);
                            showAlert({
                                type: 'danger',
                                message: ASYNC_STATE.LIST_CHANGES_FAIL_MESSAGE(item.listName, item.revisionId),
                                linkText: 'View list revision',
                                linkTo: `/lists/${id}/revision-history`,
                                linkType: 'link'
                            });
                        }

                        prevStatusMap.set(item.listId, item.status);
                    });

                    setListPollingData(newData);
                },
                onError: (error) => {
                    console.error('Polling error in internal list polling:', error);
                }
            });
        }
    }, []);

    return null;
};

export default GlobalPollerManager;
